const styles = () => ({
  cell: {
    textAlign: 'left'
  },
  spinner: {
    fontSize: '20px'
  },
  loading: {
    opacity: '.5',
    pointerEvents: 'none'
  }
})

export default styles
